import React, { useMemo } from 'react';
import { IButton } from 'components/TableHeader/TableHeader';
import SingleHeaderButton from './SingleHeaderButton';
import styles from 'assets/jss/material-dashboard-pro-react/components/tableHeaderStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IHeaderButtonsProps {
	buttons?: IButton | IButton[];
}

const HeaderButtons = ({ buttons }: IHeaderButtonsProps) => {
	const classes = useStyles();

	const renderButtons = useMemo(() => {
		if (Array.isArray(buttons)) {
			return (
				<>
					{buttons.map((singleButton, index) => (
						<SingleHeaderButton key={index} button={singleButton} />
					))}
				</>
			);
		}
		if (buttons) {
			return <SingleHeaderButton button={buttons} />;
		}
		return null;
	}, [buttons]);

	return <div className={classes.headerButtonsWrapper}>{renderButtons}</div>;
};

export default HeaderButtons;
